<p>Vänligen vänta...</p>
<mat-spinner [diameter]="50"/>